import React, { useEffect, useMemo, useState } from 'react';

import './bookSession.scss';

import { getStrategySessionLink } from '@/utils/ts/userUtils';
import { STRATEGY_SESSION_MAPPING } from '@Saral-Influencer-Marketing/saral-utils/src/constants/support';
import { InlineWidget } from 'react-calendly';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { setUserDetails } from '../../../redux/user/userActions';
import { getUserInfo } from '../../../services/list.service';
import LeftArrow from '../../Icons/icons/LeftArrow';

const BookSession = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { userDetails } = useSelector((s) => s.user);
  const dispatch = useDispatch();

  const [strategySessionLink, setStrategySessionLink] = useState(STRATEGY_SESSION_MAPPING['support@getsaral.com']);

  const fetchUserDataIfNotPresent = async () => {
    if (!Object.keys(userDetails).length) {
      const response = await getUserInfo(); // api call
      if (response?.status) {
        const strategySession = getStrategySessionLink(response?.data?.trialGrantedBy || '');
        if (strategySession) {
          setStrategySessionLink(strategySession);
        }
        dispatch(setUserDetails(response.data));
      }
    }
  };

  useEffect(() => {
    fetchUserDataIfNotPresent();
  }, []);

  const preFill = useMemo(() => {
    let name = '';

    if (userDetails?.first_name?.length || userDetails?.last_name?.length) {
      name = `${userDetails.first_name} ${userDetails.last_name}`;
    }

    return { name, email: userDetails.email };
  }, [userDetails]);

  return (
    <div className="strategy-booking-container">
      <div className="strategy-booking-header">
        <div className="back-button" onClick={() => navigate(`/dashboard${search}`)}>
          <LeftArrow /> Go Back
        </div>
        <img className="logo-placeholder" src="./logo.png" height={90} width={'auto'} alt="saral logo" />
      </div>
      <div className="title-container">
        <div className="title">Schedule a Strategy Session with us</div>
        <div className="sub-title">
          Get personalized guidance for your influencer marketing program. Choose a time slot below, and let's boost
          your success together!
        </div>
      </div>
      <InlineWidget prefill={preFill} styles={{ height: '1000px' }} url={strategySessionLink} />
    </div>
  );
};

export default BookSession;
